export default function AssetsTableCell({ children }) {
    return (
        <td className="px-3 py-2 text-sm text-gray-600 break-words">
            {children}
        </td>
    );
}